import { IHttpApi } from '@cian/http-api/shared';
import { ILogger } from '@cian/logger/shared';

import { fetchGetUserData } from '../../repositories/users/v1/get-user-data/apiHelpers';
import { TGetUserDataResponse } from '../../repositories/users/v1/get-user-data/types';
import { TUser } from '../../types/currentUser';
import { UnknownError } from '@cian/peperrors';

interface IDependencies {
  httpApi: IHttpApi;
  logger: ILogger;
}

export async function resolveUser({ httpApi, logger }: IDependencies): Promise<TUser> {
  try {
    const result: TGetUserDataResponse = await fetchGetUserData({
      httpApi,
    });

    return result.response.user ?? null;
  } catch (error) {
    if (error.statusCode === 400) {
      return null;
    }

    logger.error(
      new UnknownError({
        message: 'Нет информации о пользователе, пользователь считается неавторизованным',
        domain: 'src/shared/services/user/service.ts',
        details: error as UnknownError,
      }),
    );

    return null;
  }
}
